import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;

  .actions {
    justify-content: center;
    display: flex;
    gap: 50px;
    width: 100%;

    .add-button {
      background-color: ${(props) => props.theme.colors.main_cta};
      color: ${(props) => props.theme.colors.widget_background};

      &:hover {
        background-color: ${(props) => props.theme.colors.widget_hover_background};
        color: ${(props) => props.theme.colors.main_cta};
      }

      &:disabled {
        cursor: default;
        background-color: ${(props) => props.theme.colors.inactive};
        color: ${(props) => props.theme.colors.black};
      }
    }
  }
  
  form {
    display: flex;

    .details-container {
      display: flex;
      flex-direction: column;
      gap: 18px;
      width: 100%;
      padding: 24px 16px 24px 0;

      .form-title {
        font-family: ManropeLight, sans-serif;
        font-size: 13px;
      }
    }
  }

  input {
    width: 100% !important;
  }

  p.warning {
    font-family: ManropeLight, sans-serif;
    font-size: 13px;
    color: ${(props) => props.theme.colors.orange};
  }

  .hidden {
    display: none;
  }
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 16px;
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
`;

export default { Wrapper, RowContainer, ErrorMessage };
